import { getAssetPath } from '@stencil/core';

export const imagePlaceholder = 'https://www.se.com/assets-search/assets/defaultImage.png';
export const imagePlaceholderSVG = 'https://www.se.com/assets-search/assets/image_placeholder.svg';
export const CDP_LOCAL_STORAGE_KEY = 'tealium_va';

export const TILE_DOCUMENTS = 'documents';
export const TILE_SOFTWARE = 'software';
export const TILE_COMPANY = 'company';
export const TILE_SERVICES = 'services';
export const TILE_SOLUTIONS = 'solutions';
export const TILE_SUPPORT = 'support';
export const TILE_BLOG = 'blog';
export const TILE_SUPPORT_COMMUNITY = 'support/community';
export const TILE_SUPPORT_VIDEO = 'support/video';

export const getImagePlaceholderSVG = () => getAssetPath('assets/svg/image_placeholder.svg');





